

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { Button } from 'antd';

const clsPrefix = 'section-requested';

export default class SectionRequested extends Component {
  static propTypes = {
    onRequestAgain: PropTypes.func,
  };
  render() {
    const { onRequestAgain } = this.props;
    return (
      <div className={classNames(`${clsPrefix}`)}>
        <h2>Request Sent</h2>
        <p>You will receive an email when your request is approved.</p>
        <Button
          type="primary"
          size="large"
          onClick={onRequestAgain}
          className="margin-top"
        >
          Request Again
        </Button>
      </div>
    );
  }
}
